export default __webpack_public_path__ + "static/media/74t.4030a7f2.jpg";